import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { Grid } from '@splidejs/splide-extension-grid';

document.addEventListener('DOMContentLoaded', () => {
	const splideContainers = document.querySelectorAll('.wp-block-knightowl-blocks-slider-loop');

	for (const container of splideContainers) {
		const splides = container.querySelectorAll('.splide');

		for (const splideElement of splides) {
			const shouldAutoScroll = splideElement.dataset.scroll === "true";
			const shouldUseGrid = splideElement.dataset.grid === "true";

			let extensions = {};

			if (shouldAutoScroll) {
				extensions.AutoScroll = AutoScroll;
			}

			if (shouldUseGrid) {
				extensions.Grid = Grid;
			}

			let splideInstance = new Splide(splideElement);
			let bar = splideElement.querySelector('.slider-progress-bar');

			if (bar) {
				splideInstance.on('mounted move', function () {
					const end = splideInstance.Components.Controller.getEnd() + 1;
					const rate = Math.min((splideInstance.index + 1) / end, 1);
					bar.style.width = String(100 * rate) + '%';
				});
			}

			splideInstance.mount(extensions);
		}
	}
});
